import { useCallback, useState } from 'react';

import { DEFAULT_TOPIC } from 'pages/ParentHelper/constants';
import { useDeleteApiParentHelperChatsByChatIdMutation } from 'shared/api/gsp';

import { scrollToTopChatHistory } from './utils';

import type {
  SetChatId,
  Topic,
  ChatId,
  SetChatTopics,
} from 'pages/ParentHelper/types';

interface UseDeleteChatArgs {
  chatId: ChatId;
  chatTopics: Topic[];
  setChatId: SetChatId;
  setChatTopics: SetChatTopics;
}
export const useDeleteChat = ({
  chatId: selectedChatId,
  chatTopics,
  setChatTopics,
  setChatId: setChatTopicId,
}: UseDeleteChatArgs) => {
  const [chatId, setChatId] = useState<ChatId>(null);
  const [deleteParentChat] = useDeleteApiParentHelperChatsByChatIdMutation();

  const deleteChat = useCallback(() => {
    if (!chatId) {
      return;
    }

    deleteParentChat({ chatId })
      .unwrap()
      .then(() => {
        const updatedChatTopics = [...chatTopics];
        const deletedChatIndex = chatTopics.findIndex(
          chat => chat.chatId === chatId,
        );

        updatedChatTopics.splice(deletedChatIndex, 1);

        setChatId(null);

        if (!updatedChatTopics.length) {
          setChatTopicId(null);
          setChatTopics([DEFAULT_TOPIC]);

          return;
        }

        if (selectedChatId !== chatId) {
          setChatTopics(updatedChatTopics);

          return;
        }

        setChatTopicId(updatedChatTopics[0].chatId); // set new active chat
        setChatTopics(updatedChatTopics);

        scrollToTopChatHistory();
      });
  }, [
    chatId,
    chatTopics,
    setChatTopics,
    selectedChatId,
    setChatTopicId,
    deleteParentChat,
  ]);

  return {
    deleteChat,
    setDeletedChatId: setChatId,
    deletedChatId: chatId, // TODO: remove after adding Notistack
  };
};
